import { lazy } from "react";
import lazyLoad from "routers/utils/lazyLoad";
//import LayoutIndex from "layout/mainLayout";

const errorRouter = [
  {
    // element: <LayoutIndex />,
    path: "/error",
    children: [
      {
        path: "403",
        element: lazyLoad(lazy(() => import("components/common/ErrorPages/403"))),
      },
      {
        path: "404",
        element: lazyLoad(lazy(() => import("components/common/ErrorPages/404"))),
      },
      {
        path: "500",
        element: lazyLoad(lazy(() => import("components/common/ErrorPages/500"))),
      },
    ]
  }
];

export default errorRouter;
